import {
  createEntityAdapter,
  createSelector,
} from '@reduxjs/toolkit';
import isProductsTab from 'utils/isProductsTab';
import { selectBoothProductsByBoothId } from 'models/boothProducts';
import { BoothTab } from './types';

export const boothTabsAdapter = createEntityAdapter<BoothTab>({});

const constanceEmptyObject = {};
export const selectBoothTabsState = (state: any) => state.cms?.boothTabs || constanceEmptyObject;

export const {
  selectIds: selectBoothTabIds,
  selectEntities: selectBoothTabEntities,
  selectAll: selectAllBoothTabs,
  selectById: selectBoothTabById,
  selectTotal: selectTotalBoothTabs,
} = boothTabsAdapter.getSelectors(selectBoothTabsState);

export const selectBoothTabsByIds = (ids: string[]) => (
  createSelector(
    selectAllBoothTabs,
    (boothTabs) => boothTabs.filter((tab) => ids.includes(tab?.id)),
  )
);

const isProductTab = (tab) => Object.values(tab?.title || {}).some(isProductsTab);

const isTabElementPresent = ({ __typename: typeName, ...content }): boolean => {
  switch (typeName) {
    case 'BoothRichtextContentElement': {
      const values = content?.contentRichtextHtml;
      return !!values && Object.values(values)?.some((richTextContent) => !!richTextContent);
    }
    case 'BoothQuestionContentElement': {
      const values = content?.question;
      return (
        !!values
        && Object.values(values).some((questionTitle) => !!questionTitle)
        && !!content?.answer
        && isTabElementPresent(content?.answer)
      );
    }
    case 'BoothImageContentElement': {
      const values = content?.image;
      return !!values && Object.values(values).some((image: any) => !!image?.originalImageUrl);
    }
    case 'BoothVideoContentElement': {
      const values = content?.videoFile;
      return !!values && Object.values(values).some((videoFile: any) => !!videoFile?.playbackUrl);
    }
    case 'BoothFileContentElement': {
      const values = content?.file;
      return !!values && Object.values(values).some((file: any) => !!file?.fileUrl);
    }
    default: {
      return false;
    }
  }
};

export const selectNonEmptyBoothTabsByIds = (ids: string[], boothId: string) => (
  createSelector(
    [selectAllBoothTabs, selectBoothProductsByBoothId(boothId)],
    (boothTabs, products) => (
      boothTabs.filter((tab) => (
        ids.includes(tab?.id) && (
          (isProductTab(tab) && products.length) || tab?.body?.filter(isTabElementPresent)?.length
        )
      ))
    ),
  )
);
